import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import Heading from '@common/Heading';
import Button from '@common/Button';

import Bundle from '@common/Bundle';
import Product from '@common/Product';

import * as styles from './bundles-and-products.module.scss';

const Default = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  const [toggle, setToggle] = useState('Bundles');
  const [products, setProducts] = useState(null);
  const [bundles, setBundles] = useState(null);
  useEffect(() => {
    const newProducts = list?.filter(x => x.__typename === 'ContentfulProduct');
    setProducts(newProducts);

    const newBundles = list?.filter(x => x.__typename === 'ContentfulBundle');
    setBundles(newBundles);
  },[data]);
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row style={{position: 'relative', marginTop: '-50px', marginBottom: '55px', zIndex: 1}}>
          <div className='d-flex col justify-content-center'>
            <Button
              onClick={() => setToggle('Bundles')}
              copy={'Bundles'}
              addClass={clsx('fs-14 shadow-none', styles.btnToggle,{[styles.btnToggleActive]:toggle === 'Bundles'})}
            />
            <Button
              onClick={() => setToggle('Products')}
              copy={'Products'}
              addClass={clsx('fs-14 shadow-none', styles.btnToggle,{[styles.btnToggleActive]:toggle === 'Products'})}
            />
          </div>
        </Row>
        {(bundles && toggle === 'Bundles') &&
          <Row className='row-cols-md-2 row-cols-xl-3 gx-3 gy-4'>
            {bundles.map((bundle, index) => (
              <div className='col d-flex flex-fill' key={index}>
                <Bundle data={bundle} showButton setMinHeight/>
              </div>
            ))}
          </Row>
        }
        {(products && toggle === 'Products') &&
          <Row className='row-cols-md-2 row-cols-xl-4 g-3'>
            {products.map((product, index) => (
              <div className='col d-flex flex-fill' key={index}>
                <Product data={product} showButton setMinHeight/>
              </div>
            ))}
          </Row>
        }
      </Container>
    </Section>
  )
}

export default Default
